import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { EyeIcon, HeartIcon, GlobeIcon, MicIcon, BookOpenIcon } from 'lucide-react';
type ContentItem = {
  icon: React.ReactNode;
  title: string;
  description: string;
  iconColor: string;
};
const items: ContentItem[] = [{
  icon: <EyeIcon className="w-6 h-6" data-id="element-15" />,
  title: 'Hechos históricos que fueron silenciados',
  description: 'Documentación rigurosa de la represión, la corrupción sistémica y las decisiones que destruyeron la nación más rica de América Latina.',
  iconColor: '#CF9B2E'
}, {
  icon: <HeartIcon className="w-6 h-6" data-id="element-16" />,
  title: 'La crisis humanitaria desde adentro',
  description: 'Escasez de medicamentos, hambre, colapso de servicios básicos. No como estadística — sino como experiencia humana vivida.',
  iconColor: '#C0392B'
}, {
  icon: <GlobeIcon className="w-6 h-6" data-id="element-17" />,
  title: 'La caída final del régimen',
  description: 'Un análisis profundo del colapso político, las traiciones internas y el momento en que el mundo finalmente no pudo seguir mirando.',
  iconColor: '#1A5276'
}, {
  icon: <MicIcon className="w-6 h-6" data-id="element-18" />,
  title: 'Lo que el mundo no quiso ver',
  description: 'La complicidad internacional, los medios que callaron y los gobiernos que miraron hacia otro lado mientras un pueblo entero sufría.',
  iconColor: '#C0392B'
}, {
  icon: <BookOpenIcon className="w-6 h-6" data-id="element-19" />,
  title: 'Profundo pero accesible para todos',
  description: 'Escrito para ser leído por cualquier persona, no solo académicos. Una narrativa que engancha desde la primera página hasta la última.',
  iconColor: '#1A5276'
}];
export function BookContents() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section ref={ref} className="w-full bg-[#111111] py-24 px-6" data-id="element-20">
      <div className="max-w-5xl mx-auto" data-id="element-21">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7
      }} className="text-center mb-16" data-id="element-22">
          <p className="text-[#CF9B2E] uppercase tracking-[0.3em] text-sm font-bold mb-4 font-['Lato']" data-id="element-23">
            Dentro del libro
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-[#F5F0E8] mb-6" data-id="element-24">
            Cinco razones para leerlo
          </h2>
          <div className="gold-divider" data-id="element-25" />
        </motion.div>

        {/* Grid */}
        <div className="flex flex-wrap justify-center gap-6" data-id="element-26">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 40
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.1 + index * 0.1
        }} className="bg-[#0a0a0a] border border-[#1e1e1e] p-8 rounded-sm group w-full md:w-[calc(50%-12px)] lg:w-[calc(33.333%-16px)]" data-id="element-27">
              <div className="mb-4" style={{
            color: item.iconColor
          }} data-id="element-28">
                {item.icon}
              </div>
              <h3 className="text-xl font-bold text-[#F5F0E8] mb-3" data-id="element-29">
                {item.title}
              </h3>
              <p className="text-[#9A9080] leading-relaxed text-sm" data-id="element-30">
                {item.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}